import { campaignAPI } from "@api";
import { PATH_PERSONAL_FITNESS, enumLanguage } from "@configs";
import { IMemberTier } from "@interfaces";
import { selectAuth, selectMerchant } from "@redux";
import { RenderMeta, useNotify } from "@utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import styled from "styled-components";
import { ArrowLeftColor } from "../icon";
interface IProps {
    socials: JSX.Element[];
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
    isConfirm?: boolean;
}

export const ComponentFitnessCampaign = (props: IProps) => {
    //page props
    const { t } = useTranslation();
    const merchant = useSelector(selectMerchant);
    const { userInfo } = useSelector(selectAuth);
    const history = useHistory();
    const { error } = useNotify();
    const { id } = useParams<{ id: string }>();
    const { themes } = useSelector(selectMerchant);
    const [showDone, setShowDone] = useState<boolean>(false);
    const [campaign, setCampaign] = useState<any>();
    const i18nextLng = window.localStorage.i18nextLng;

    const getCampaign = async () => {
        try {
            const get = await campaignAPI.getCampaign(id);

            if (get.data) {
                setCampaign(get.data);
            }
        } catch (err: any) {
            // err.response?.data?.message ? error(err.response?.data?.message) : error(err.message);
            console.log(err);
        }
    };

    const joinCampaign = async () => {
        try {
            const get = await campaignAPI.clientRegisterCampaign(id);
            if (get.data) {
                setShowDone(false);
                history.push(PATH_PERSONAL_FITNESS + "/" + id);
            }
        } catch (err: any) {
            setShowDone(false);
            err.response?.data?.message ? error(err.response?.data?.message) : error(err.message);
            console.log(err);
        }
    };

    useEffect(() => {
        getCampaign();
    }, []);

    return (
        <>
            <RenderMeta title={t("meta.campaign_page")} />
            <StyledMainFitness
                themeColor={themes?.themeColor!}
                textColor={campaign?.campaignTextColor}
                campaignColor={campaign?.campaignColor}
            >
                <div className="backIcon" onClick={() => history.push("/")}>
                    <ArrowLeftColor color={themes?.themeColor} />
                    {/* <span>{t("page.back")}</span> */}
                </div>
                <div className="layout-main-fitness">
                    <div className="logo-main-fitness">
                        {/* <img src={merchant?.themes?.logoSmallUrl || "../../images/logo-club-wellness.svg"} alt="" /> */}
                        {/* <img src="../../images/logo-club-wellness.svg" alt="" /> */}
                        <img
                            src={campaign?.campaignLogo || "../../images/logo-club-wellness.svg"}
                            alt=""
                        />
                    </div>
                    <div className="banner-main-fitness">
                        <span>
                            <img
                                src={
                                    campaign?.campaignImage ||
                                    "../../images/img-upload-activity-01.png"
                                }
                                alt=""
                            />
                        </span>
                    </div>
                    <div className="title-main-fitness">
                        {/* Campaign
                        <span>Active Running</span> */}
                        {i18nextLng === enumLanguage.EN || i18nextLng === enumLanguage.EN_GB
                            ? campaign?.name?.EN
                            : campaign?.name?.TH}
                        {/* {campaign?.name?.EN} */}
                    </div>
                    <div className="detail-main-fitness">
                        {i18nextLng === enumLanguage.EN || i18nextLng === enumLanguage.EN_GB
                            ? campaign?.description?.EN
                            : campaign?.description?.TH}
                    </div>
                    <div className="btn-page">
                        <StyledMainJoin
                            className="btn-redeem"
                            themeColor={themes?.themeColor!}
                            onClick={() => {
                                if (campaign?.users?.some((user: any) => user === userInfo?._id)) {
                                    history.push(PATH_PERSONAL_FITNESS + "/" + id);
                                } else {
                                    setShowDone(true);
                                }
                            }}
                        >
                            {campaign?.users?.some((user: any) => user === userInfo?._id) ? (
                                <span>{t("page.campaign.details")}</span>
                            ) : (
                                <span>{t("page.campaign.joinnow")}</span>
                            )}
                        </StyledMainJoin>
                    </div>
                </div>
                {showDone ? (
                    <StyledPopupRedeem themeColor={themes?.themeColor!}>
                        <div className="box-popupconfirm">
                            <div className="img-popupconfirm">
                                <img
                                    src={
                                        campaign?.confirmationImage ||
                                        "../../images/img-popup-fitness.png"
                                    }
                                    alt=""
                                />
                            </div>
                            <div className="title">
                                <div className="text-sub-header">
                                    Confirm to join campaign{" "}
                                    {i18nextLng === enumLanguage.EN ||
                                    i18nextLng === enumLanguage.EN_GB
                                        ? campaign?.name?.EN
                                        : campaign?.name?.TH}{" "}
                                    ?
                                </div>
                            </div>
                            <div className="btn-popupconfirm">
                                <StyledUsedBtn
                                    className="btn-cancel"
                                    themeColor={themes?.themeColor!}
                                    onClick={() => setShowDone(false)}
                                >
                                    {t("page.cancel")}
                                </StyledUsedBtn>
                                <StyledUsedBtn
                                    className="btn-redeem"
                                    themeColor={themes?.themeColor!}
                                    onClick={() => joinCampaign()}
                                >
                                    {t("page.confirm")}
                                </StyledUsedBtn>
                            </div>
                        </div>
                    </StyledPopupRedeem>
                ) : null}
            </StyledMainFitness>
        </>
    );
};

const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.themeColor};
    background: ${(p) => p.theme.colors.card};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    &:active {
        background: ${(p) => p.themeColor};
        color: ${(p) => p.theme.colors.color};
    }
`;

const StyledPopupRedeem = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    left: 0;
    .box-popupconfirm {
        background: ${(p) => p.theme.colors.card};
        padding: 65px 28px 28px;
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .img-popupconfirm {
            position: absolute;
            top: -50px;
            left: 50%;
            transform: translateX(-50%);
            width: 100px;
            height: 100px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .btn-popupconfirm {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
            .btn-redeem {
                color: #fff;
                background-color: ${(p) => p.themeColor};
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
                font-weight: 600;
            }
            .btn-cancel {
                color: #000;
                background-color: #fff;
                border: 1px solid #e1e1e1;
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
        }
    }
    .title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        justify-content: center;
        text-align: center;
        .text-sub-header {
            font-size: 18px;
            line-height: 21px;
            color: #000;
            font-weight: 600;
        }
    }
`;

const StyledMainFitness = styled.div<{
    themeColor: string;
    textColor: string;
    campaignColor: string;
}>`
    width: 100%;
    margin: 0 auto;
    height: 100vh;
    background-color: ${(p) => p.campaignColor};
    /* background: rgb(118, 192, 217); */
    /* background: linear-gradient(0deg, rgba(118, 192, 217, 1) 0%, rgba(254, 171, 80, 1) 65%); */
    position: relative;
    padding: 50px 16px;
    overflow: scroll;
    .backIcon {
        position: absolute;
        top: 20px;
        left: 20px;
        cursor: pointer;
        z-index: 1;
        display: flex;
        align-items: center;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    .logo-main-fitness {
        margin-bottom: 30px;
        display: block;
        text-align: center;
        img {
            max-width: 168px;
            width: 100%;
            height: auto;
        }
    }
    .banner-main-fitness {
        position: relative;
        width: 100%;
        padding-top: 80%;
        margin-bottom: 30px;
        border-radius: 14px;
        overflow: hidden;
        span {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
    .title-main-fitness {
        margin-bottom: 16px;
        font-size: 33px;
        line-height: 45px;
        font-style: italic;
        font-weight: 500;
        /* color: rgb(255, 255, 255); */
        /* text-shadow: rgba(254, 171, 80, 0.84) 3px 3px 1px; */
        color: ${(p) => p.textColor};
        text-align: center;
        span {
            display: block;
            font-weight: 500;
        }
    }
    .detail-main-fitness {
        font-size: 24px;
        color: ${(p) => p.textColor};
        /* color: #fff; */
        font-weight: 500;
        text-align: center;
        margin-bottom: 22px;
    }
`;

const StyledMainJoin = styled.button<{ themeColor: string }>`
    padding: 14px 32px;
    /* color: #374e77; */
    background: ${(p) => p.themeColor};
    color: #fff;
    // border: 0.5px solid ${(p) => p.themeColor};
    border: none;
    border-radius: 14px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    height: 45px;
    width: 100%;
    &:active {
        opacity: 0.8;
    }
`;
